import { ValidationObserver, ValidationProvider } from "vee-validate";
import { EventLocationsMixin } from "@/mixins/EventLocations";
import { MaintenanceForm } from "@/models/maintenance/MaintenanceForm";
import { hasAccess } from "@/utils/accessControl/accessControl";
import { AccessMatrixKeys } from "@/utils/accessControl/accessMatrixKeysEnum";

export default {
  name: "ScheduledMaintenanceAddFormDlg",
  mixins: [
    EventLocationsMixin
  ],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      form: null,
      isAdd: true,
      indexForm: null
    }
  },
  computed: {
    templates() {
      return this.$store.state.maintenanceModule.maintenanceTemplates;
    },
    currentUser(){
        return this.$store.state.authModule.user
    },
    canAddEventLocation(){
        return hasAccess(this.currentUser.accessLevel, AccessMatrixKeys.Calendar_Events_AddLocation)
    }
  },
  methods: {
    open(form, index: number) {
      this.dialog = true;
      this.form = form ?? new MaintenanceForm();
      this.isAdd = !form;
      this.indexForm = index ? index : null;
      this.$store.dispatch("getMaintenanceTemplates");
    },
    close() {
      this.dialog = false;
      this.$refs.observer.reset();
    },
    addForm() {
      if(this.isAdd) {
        const template = this.templates.find(x => x.id === this.form.templateId);
        this.form.template = template?.template;
        this.form.templateName = template?.name;
        this.form.facilityId = this.$store.state.authModule.currentFacility;
        this.$emit("addNewForm", this.form.toObject());
      }

      this.close();
    }
  }
}